import { Flex, Segmented, Tag, Text } from '@nula/core-ui';
import type { BillingInterval } from './types';
import styles from './interval-toggle.module.css';

interface IntervalToggleProps {
  value: BillingInterval;
  onChange: (interval: BillingInterval) => void;
  /** Approximate annual saving, shown as a badge on the Annual option. */
  savingsLabel?: string;
}

export function IntervalToggle({
  value,
  onChange,
  savingsLabel = 'Save 2 months',
}: IntervalToggleProps) {
  return (
    <Segmented
      value={value}
      onChange={(v) => onChange(v as BillingInterval)}
      options={[
        { label: <Text size="sm">Monthly</Text>, value: 'month' },
        {
          label: (
            <Flex align="center" gap="xs" className={styles.annualLabel}>
              <Text size="sm">Annual</Text>
              <Tag color="success">{savingsLabel}</Tag>
            </Flex>
          ),
          value: 'year',
        },
      ]}
    />
  );
}
